import { isInventoryOrgSession, type SessionContextType } from '../contexts/SessionContext';

/**
 * Whether the user can see inventory reporting (the Reporting Inventory tab and
 * the Auditing inventory source). Requires the org to have inventory enabled,
 * so full-time orgs without inventory never see it, even when a role's defaults
 * include `inventory-reporting`.
 */
export function hasInventoryReporting(ctx: SessionContextType | undefined): boolean {
    if (!ctx || ctx.isAuthenticated !== true) return false;
    if (ctx.inventoryEnabled !== true) return false;
    if (!ctx.tabs?.includes('inventory')) return false;
    return ctx.permissions?.includes('inventory-reporting') === true;
}

/**
 * Whether Reporting should be reachable (route, sidebar, command search).
 * Inventory-only orgs have no reports besides Inventory, so the tab alone is
 * not enough there; other orgs are gated by the tab as before.
 */
export function canOpenReporting(ctx: SessionContextType | undefined): boolean {
    if (!ctx?.tabs?.includes('reporting')) return false;
    if (isInventoryOrgSession(ctx)) return hasInventoryReporting(ctx);
    return true;
}
